<template>
  <div class="curve_node">
    <div class="curve_node_box">
      <div class="node_title">
        设备状态 <span @click="closeControlpopover">×</span>
      </div>
      <div class="node_inner">
        <div class="node_add_box">
          <DataAdd
            @closeControlpopover="closeControlpopover"
            @loadDataList="loadDataList"
            @refreshList="refreshList"
            :enableSignList.sync="enableSignList"
            :decimalPlaceList="decimalPlaceList"
            :staId="staId"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import myApi from "@/util/my-api";
import myConst from "@/util/my-const";

import DataAdd from "./components/data_add.vue";

import fun from "@/util/util";

export default {
  props: {
    nodeData: {
      type: Object,
      default: () => {
        {
        }
      },
    },
    staId: {
      type: Number,
      default: 0,
    },
    enableSignList: {
      type: Array,
      default: () => {
        [];
      },
    },
  },
  components: {
    DataAdd,
  },
  data() {
    return {
      //字典
      sourceTypeList: [], //源类型
      DataList: [], //节点列表
      nodeId: 0, //节点id

      devList: [], //设备列表
      curveList: [], //瞬时量列表
      cumulateList: [], //累积量列表
      cumulateTypeList: [], //累积量类型
      iconList: [], //图标列表
      decimalPlaceList: [], //小数位
      infoModuleTypeList: [],
      controlList: [],

      currentPage: 1,
      pageSize: 150,
      pageTotal: 0,
      loading: false,
    };
  },
  computed: {},
  mounted() {},
  created() {
    this.$nextTick(() => {
      this.loadDeviceList(); //加载设备列表
      this.loadDict(); //加载字典
      this.loadDataList(); //加载节点列表
      this.loadCurveList();
      this.loadCumulateList();
      this.getInfoModuleType();
      this.loadControlList();
    });
  },
  methods: {
    //关闭弹窗
    closeControlpopover() {
      this.$emit("changeNodeShowStateAdd");
    },
    refreshList() {
      this.$emit("selectButClick");
    },
    //加载字典
    loadDict() {
      //源类型
      this.$axios
        .get(myApi.getTopologyPointDataModel)
        .then((res) => {
          if (res.data.code === myConst.code.success) {
            this.sourceTypeList = res.data.data;
          } else {
            this.sourceTypeList = [];
          }
        })
        .catch(() => {
          this.dataModuleList = [];
        });
      //累积量类型
      this.$axios
        .get(myApi.getEmsCumulateType)
        .then((res) => {
          if (res.data.code === myConst.code.success) {
            this.cumulateTypeList = res.data.data;
          } else {
            this.cumulateTypeList = [];
          }
        })
        .catch(() => {
          this.cumulateTypeList = [];
        });
      //小数位数
      this.$axios
        .get(myApi.getDecimalLen)
        .then((res) => {
          if (res.data.code === myConst.code.success) {
            this.decimalPlaceList = res.data.data;
          } else {
            this.decimalPlaceList = [];
          }
        })
        .catch(() => {
          this.decimalPlaceList = [];
        });
      //获取图标
      this.$axios.get(myApi.getDisplayIcon).then((res) => {
        if (res.data.code === myConst.code.success) {
          this.iconList = res.data.data;
        } else {
          this.iconList = [];
        }
      });
    },
    //加载设备列表
    loadDeviceList() {
      this.$axios
        .get(myApi.getDevListNew + "?stationId=" + this.staId)
        .then((res) => {
          if (res.data.code === myConst.code.success) {
            this.devList = res.data.data;
          } else {
            this.devList = [];
          }
        })
        .catch(() => {
          this.devList = [];
        });
    },
    //加载节点列表
    loadDataList(pageIndex) {
      this.loading = true;
      if (fun.isNull(pageIndex)) {
        pageIndex = 1;
      }
      let data = {
        pageIndex: pageIndex,
        pageSize: this.pageSize,
        // topologyId: this.nodeData.topologyId
      };
      // this.$axios.post(myApi.getTopologyPointList, data).then(res => {
      //   if (res.data.code === myConst.code.success) {
      //     this.DataList = res.data.data.list
      //     this.pageTotal = res.data.data.total
      //   } else {
      //     this.DataList = []
      //   }
      //   this.loading = false
      // }).catch(()=>{
      //   this.loading = false
      // })
    },
    //加载曲线列表
    loadCurveList() {
      this.$axios
        .get(myApi.stationCurveGetListBus + "?staId=" + this.staId)
        .then((res) => {
          if (res.data.code === myConst.code.success) {
            this.curveList = res.data.data;
          } else {
            this.curveList = [];
          }
        })
        .catch(() => {
          this.curveList = [];
        });
    },
    //加载累积量列表
    loadCumulateList() {
      this.$axios
        .get(myApi.stationCumulateGetListBus + "?staId=" + this.staId)
        .then((res) => {
          if (res.data.code === myConst.code.success) {
            this.cumulateList = res.data.data;
          } else {
            this.cumulateList = [];
          }
        })
        .catch(() => {
          this.cumulateList = [];
        });
    },

    //获取信息模块类型
    getInfoModuleType() {
      this.$axios.get(myApi.getInfoModuleType).then((res) => {
        if (res.data.code === myConst.code.success) {
          this.infoModuleTypeList = res.data.data;
        } else {
          this.infoModuleTypeList = [];
        }
      });
    },
    //查询控制器列表
    loadControlList() {
      let data = {
        staId: this.staId,
      };
      this.$axios.post(myApi.getControlList, data).then((res) => {
        if (res.data.code === myConst.code.success) {
          this.controlList = res.data.data;
        } else {
          this.controlList = [];
        }
      });
    },
    //切换为详情界面
    changeDetail(id) {
      this.nodeId = id;
      this.activeName = "third";
    },
    //   切换为编辑界面
    changeEdit(id) {
      this.nodeId = id;
      this.activeName = "fourth";
    },
  },
};
</script>

<style scoped>
.curve_node {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.curve_node_box {
  width: 90%;
  height: 80%;
  position: relative;
  background: url("~../../../../assets/images/iems/control_win_bag.png")
    no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  box-sizing: border-box;
  font-size: 1.4rem;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.node_title {
  padding-top: 0.7rem;
  height: 5rem;
  width: 100%;
  color: #000f21;
  font-size: 1.8rem;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  position: relative;
}

.node_title > span {
  position: absolute;
  display: flex;
  right: 1.5rem;
  width: 1.4rem;
  height: 1.4rem;
  font-size: 2.6rem;
  color: #00dafc;
  cursor: pointer;
}

.node_inner {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0rem 1.5rem 2.5rem 1.5rem;
  box-sizing: border-box;
}

.node_list_box {
  width: 100%;
  height: 100%;
}

.my_el_table {
  border: 0.1rem solid #00dafc;
}

.node_add_box {
  width: 100%;
  flex: 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
}

.node_controls {
  width: 100%;
}

::v-deep .el-tab-pane {
  display: flex;
  width: 100%;
  flex: 1;
}

::v-deep .el-tabs {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

::v-deep .el-tabs--card > .el-tabs__header {
  border-bottom: 0.1rem solid #00dafc;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: 0.1rem solid #00dafc;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item {
  border-bottom: 0.1rem solid transparent;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item {
  border-left: 0.1rem solid #00dafc;
}

::v-deep .el-tabs__item {
  font-size: 1.4rem;
  color: #fff;
  padding: 0 2rem;
  height: 4rem;
  line-height: 4rem;
}

::v-deep .el-tabs__item:hover {
  color: #fdd73c;
  cursor: pointer;
}

::v-deep .el-tabs__item.is-active {
  color: #fdd73c;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item:first-child {
  border-left: none;
}

::v-deep .el-tabs__content {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
}

::v-deep .el-tab-pane {
  /* width: 100%;
  height: 100%; */
}

::v-deep .el-tabs__header {
  margin: 0;
}
</style>
